import { HorizontalContainer, IconButton } from '@american-autonomy/ag-ui';

import TriangleArrowIcon from 'components/icons/TriangleArrowIcon';
import NavigationText from 'components/text/NavigationText';

import useOnboardingStepNavigation from './hooks/useOnboardingStepNavigation/index.ts';
import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const OnboardingStepCount: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => {
    const { STEP_COUNT } = useTranslation();
    const { canGoBack, canGoForward, handleGoBack, handleGoForward, stepNumber } =
        useOnboardingStepNavigation();

    const highlightArrowRightStyles = canGoBack ? styles.activeArrow : '';

    const highlightArrowLeftStyles = canGoForward ? styles.activeArrow : '';

    return (
        <HorizontalContainer
            className={`${className} ${styles.onboardingStepCount}`}
            testId={testId}>
            <IconButton className={styles.iconButton} onClick={handleGoBack}>
                <TriangleArrowIcon
                    className={`${styles.triangleArrowIconLeft} ${highlightArrowRightStyles}`}
                />
            </IconButton>

            <NavigationText className={styles.navigationText}>
                {STEP_COUNT(stepNumber)}
            </NavigationText>

            <IconButton className={styles.iconButton} onClick={handleGoForward}>
                <TriangleArrowIcon
                    className={`${highlightArrowLeftStyles} ${styles.triangleArrowIconRight}`}
                />
            </IconButton>
        </HorizontalContainer>
    );
};

export default OnboardingStepCount;
